import { useQuery } from "@tanstack/react-query"

import { listFileApi } from "@/api/api"
import { queryKeys } from "@/lib/query-keys"

type UseIndexedFilesQueryParams = {
  sessionId: string | undefined
  token: string | undefined
  enabled?: boolean
  projectId?: string
}

export function useIndexedFilesQuery({
  sessionId,
  token,
  enabled = true,
  projectId,
}: UseIndexedFilesQueryParams) {
  const effectiveSessionId = sessionId ?? "no-session"

  return useQuery({
    queryKey: queryKeys.indexedFiles(effectiveSessionId),
    queryFn: async () => {
      // Double-check enabled flag in queryFn to prevent refetch() bypassing enabled
      if (!sessionId || !enabled) return [] as string[]
      return await listFileApi(sessionId, token, projectId)
    },
    enabled: Boolean(sessionId) && enabled,
    // Prevent automatic refetches when query is meant to be disabled
    refetchOnMount: enabled,
    refetchOnWindowFocus: enabled,
    refetchOnReconnect: enabled,
  })
}
